import React, {
    useState,
    useEffect
}                               from "react";
import { Link }                 from "react-router-dom";
import Logo                     from './logo'
import { 
  LanguageButton,
  NavbarItem 
}                               from './index'
import { useTranslate }         from '../../../../hooks/use';


function Navbar() {
  const t                   = useTranslate();
  const [click, setClick]   = useState(false);
  const [button, setButton] = useState(true);
  const [icon, setIcon]     = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
      setIcon(false);
    } else {
      setButton(true);
      setIcon(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="application-header-navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
            <Logo />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <NavbarItem 
              to              = '/services'
              closeMobileMenu = { closeMobileMenu} 
              itemName        = "services"
            >
              { t(`Static_Label_Navbar_Services`) }
            </NavbarItem>
            <NavbarItem 
              to              = '/sector'
              closeMobileMenu = { closeMobileMenu}
              itemName        = "sector"
            >
              { t(`Static_Label_Navbar_Sector`) }
            </NavbarItem>
            <NavbarItem 
              to              = '/blog'
              closeMobileMenu = { closeMobileMenu} 
              itemName        = "blog"
            >
              { t(`Static_Label_Navbar_Blog`) }
            </NavbarItem>
            <NavbarItem 
              to              = '/about'
              closeMobileMenu = { closeMobileMenu} 
              // itemName        = "aboutUs"
            >
              { t(`Static_Label_Navbar_About_Us`) }
            </NavbarItem>
            <NavbarItem 
              to              = '/contact'
              closeMobileMenu = { closeMobileMenu} 
              // itemName        = "contact"
            >
              { t(`Static_Label_Navbar_Contact`) }
            </NavbarItem>
            <li className="language-center">
                {/* <LanguageButton /> */}
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;